import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { observer } from 'mobx-react';

import { Button, Chip, FieldLabel, Flex, TextField } from '@servicetitan/anvil2';

interface DomainsListFieldProps {
    label: string;
    value: string[];
    onChange: (domains: string[]) => void;
    disabled?: boolean;
}

export const DomainsListField = observer(
    ({ label, value, onChange, disabled }: DomainsListFieldProps) => {
        const [inputValue, setInputValue] = useState('');

        const handleAdd = () => {
            const domain = inputValue.trim();

            if (!domain || value.includes(domain)) {
                return;
            }

            onChange([...value, domain]);
            setInputValue('');
        };

        const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                handleAdd();
            }
        };

        const handleRemove = (domain: string) => {
            onChange(value.filter(existing => existing !== domain));
        };

        return (
            <Flex direction="column" gap="2">
                <FieldLabel>{label}</FieldLabel>

                {value.length > 0 && (
                    <Flex wrap="wrap" gap="1">
                        {value.map(domain => (
                            <Chip
                                key={domain}
                                label={domain}
                                onClose={disabled ? undefined : () => handleRemove(domain)}
                            />
                        ))}
                    </Flex>
                )}

                <Flex alignItems="flex-start" gap="2">
                    <TextField
                        flexGrow={1}
                        value={inputValue}
                        placeholder="example.com"
                        disabled={disabled}
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                            setInputValue(event.target.value)
                        }
                        onKeyDown={handleKeyDown}
                    />
                    <Button appearance="secondary" disabled={disabled} onClick={handleAdd}>
                        Add
                    </Button>
                </Flex>
            </Flex>
        );
    },
);
